module.exports = __webpack_public_path__ + "static/media/gluten-free.f2cb9810.png";